import React from 'react'
import { Card, Col, Row } from 'reactstrap'
import { orderByVendorCode } from '../../../_helper/helper'

const HSAAndPPO = [
  {
    value: "I",
    className: "Class I",
    label: "Subscriber Only",
    key: "HSAANDPPO"
  },
  {
    value: "II",
    className: "Class II",
    label: "Subscriber + Spouse/Domestic Partner",
    key: "HSAANDPPO"
  },
  {
    value: "III",
    className: "Class III",
    label: "Subscriber + Child(ren)",
    key: "HSAANDPPO"
  },
  {
    value: "IV",
    className: "Class IV",
    label: "Subscriber + Spouse/Dom. Partner & Child(ren)",
    key: "HSAANDPPO"
  }
]

const DeductionRSP = [
  {
    value: "I",
    className: "Class I",
    label: "RSP Subscriber Only",
    key: "DeductionRSP"
  },
  {
    value: "IIa",
    className: "Class IIa",
    label: "RSP Subscriber + RSP Spouse/Domestic Partner",
    key: "DeductionRSP"
  },
  {
    value: "IIb",
    className: "Class IIb",
    label: "RSP Subscriber + Non Medicare Spouse/Dom. Partner",
    key: "DeductionRSP"
  },
  {
    value: "III",
    className: "Class III",
    label: "RSP Subscriber + Non Medicare Child(ren)",
    key: "DeductionRSP"

  },
  {
    value: "IVa",
    className: "Class IVa",
    label: "RSP Subscriber + RSP Spouse/Dom. Partner + Non Medicare Child(ren)",
    key: "DeductionRSP"

  },
  {
    value: "IVb",
    className: "Class IVb",
    label: "RSP Subscriber + Non Medicare Spouse/Dom. Partner & Child(ren)",
    key: "DeductionRSP"
  },
]

const healthPlamArray = [
  {
    title: "HSA 2000",
    text: "Single Ded. is $2,000 / Family Ded. is $4,000.",
    key: "healthPlan"
  },
  {
    title: "PPO 1500",
    text: "Single Ded. is $1,500 / Family Ded. is $3,0000",
    key: "healthPlan"
  },
  {
    title: "Retiree Supplemental Plan(RSP)",
    text: "Must be enrolled in Medicare A and B and you must fill out Other Insurance below.",
    key: "healthPlan"
  }
]




const companyArray = [
  {
    "vendor_name": "Retiree Company A",
    "vendor_items": [
      {
        "vendor_code": "Retiree Supplemental Plan(RSP)",
        "vendor_desc": "Must be enrolled in Medicare A and B and you must fill out Other Insurance below.",
        "vendor_desc1": "Must be enrolled in Medicare A and B and you must fill out Other Insurance below.",
        'key': "retireePlan",
        "classInfo": [
          {
            value: "I",
            className: "Class I",
            label: "RSP Subscriber Only",
            key: "retireeClass",
            "amount": "226.40",
            "empRate": "0.00",
            "govRate": "226.40"
          },
          {
            value: "IIa",
            className: "Class IIa",
            label: "RSP Subscriber + RSP Spouse/Domestic Partner",
            key: "retireeClass",
            "amount": "443.41",
            "empRate": "0.00",
            "govRate": "443.41"
          },
          {
            value: "IIb",
            className: "Class IIb",
            label: "RSP Subscriber + Non Medicare Spouse/Dom. Partner",
            key: "retireeClass",
            "amount": "1177.32",
            "empRate": "25.00",
            "govRate": "1152.32"
          },
          {
            value: "III",
            className: "Class III",
            label: "RSP Subscriber + Non Medicare Child(ren)",
            key: "retireeClass",
            "amount": "432.32",
            "empRate": "25.00",
            "govRate": "407.32"
          },
          {
            value: "IVa",
            className: "Class IVa",
            label: "RSP Subscriber + RSP Spouse/Dom. Partner + Non Medicare Child(ren)",
            key: "retireeClass",
            "amount": "1429.39",
            "empRate": "25.00",
            "govRate": "1404.39"
          }, {
            value: "IVb",
            className: "Class IVb",
            label: "RSP Subscriber + Non Medicare Spouse/Dom. Partner & Child(ren)",
            key: "retireeClass",
            "amount": "1429.39",
            "empRate": "25.00",
            "govRate": "1404.39"
          }
        ]
      },

    ]
  },


]


const RetireePlan = (props) => {
  const { renderTextInput, renderCheckbox, renderGroupCheckbox, renderDropDown, renderDateInput, setFieldValue } = props
  return (
    <Card style={{ padding: "20px" }}>
      {/* <Row>
        <Col md={3}><b style={{ fontSize: "18px" }}>Health Plan Choice</b></Col>
        {healthPlamArray?.map((item) => {
          return (
            <>
              <Col md={3}>
                <div style={{ display: "flex" }}>
                  <div>{renderCheckbox("large",item.key , item.title)}</div> <div style={{ alignSelf: "center" }}> <b style={{ fontSize: "15px", alignItems: "center" }}>{item.title}</b>
                    <div>{item.text}</div></div>
                </div>
              </Col>
            </>
          )
        })}
      </Row> */}

      <Row>

        {/* {companyArray.map((item, ind) => {
              return <Col md={ 12 } className='p-2' key={ind}>
                <Card className='rounded' style={{margin:'10px',marginBottom:'15px'}}>
                  
                <table className=' ' style={{ width: "100%" }}>
                    <tr style={{ margin: "10px" }}>
                      <th className='p-2 bg-primary text-white rounded-top'>{ item.vendor_name }</th>
                      
                    </tr>
                    {item?.vendor_items?.length ? item.vendor_items.map((i, index) => {
                      return <> <tr style={{ cursor: "pointer", backgroundColor: '#ffe4c4', padding: "5px" }} key={index}
                        onClick={(e) => { 
                          setFieldValue("retireeVendor",item?.vendor_name)
                          setFieldValue("retireePlan",item?.vendor_code)
                        }}
                      >
                        <td>
                          { renderGroupCheckbox("medium", 'retireePlan' ,   i.vendor_code,{matchkey:'retireeVendor',matchvalue:item?.vendor_name} ) } <b>{ i.vendor_code }</b>
                        </td>
                        
                      </tr>
                      {
                          i?.classInfo.map((k) => {
                            return <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}><div style={{ display: "flex" }}>
                            <div style={{width:'140px'}}>{renderGroupCheckbox("small",k.key,k.value,{changeTarget1:'retireeVendor',changeTargetValue1:item?.vendor_name,changeTarget2:'retireePlan',changeTargetValue2:i.vendor_code,matchkey:'retireeVendor',matchvalue:item?.vendor_name,matchkey1:'retireePlan',matchvalue1:i.vendor_code})}  <b style={{ alignSelf: "center" }}>{k.className}</b></div>
                            <div style={{ marginTop: "8px" }}>{k.label} {k.amount?`$${k.amount}`:''}</div>
                          </div></tr>
                          })
                        }
                        </>
                    }) : null}
                  </table>
                </Card>
              </Col>
            })} */}

        {orderByVendorCode(companyArray).map((item, ind) => {
          return <Col md={6} className='p-2' key={ind}>
            <Card className='rounded' style={{ margin: '10px', marginBottom: '15px' }}>
              <table className=' ' style={{ width: "100%" }}>
                <tr style={{ margin: "10px" }}>
                  {/* <td> */}
                  <th colSpan={6} className='p-2 bg-primary text-white rounded-top'>{item.vendor_name}</th>
                  {/* </td> */}
                </tr>


                {item?.vendor_items?.length ? item.vendor_items.map((i, index) => {
                  return (
                    <tr style={{ cursor: "pointer", backgroundColor: '#ffe4c4', padding: "5px" }} key={index}
                      onClick={(e) => {
                        setFieldValue("retireeVendor", item?.vendor_name)
                        setFieldValue("retireePlan", item?.vendor_code)
                      }}
                    >
                      <td>
                        {renderGroupCheckbox("medium", 'retireePlan', i.vendor_code, { matchkey: 'retireeVendor', matchvalue: item?.vendor_name })}

                      </td>
                      <td colSpan={5} style={{ width: "80px" }}>
                        <b>{i.vendor_code}</b>
                      </td>
                      {/* <td></td>
                  <td> <b>Total</b> </td>
                  <td> <b>Gov.</b> </td>
                  <td> <b>Emp.</b> </td> */}

                    </tr>
                  )
                }) : null}
                <tr>
                  {/* <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}> */}

                  <td>

                  </td>
                  <td>
                  </td>
                  <td style={{ width: "200px" }}> </td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Emp</td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Govt</td>
                  <td style={{ borderLeft: "1px solid #d2d2d2", fontWeight: "600" }}>Total</td>
                  {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.govRate ? `$${k.govRate}` : ''} <b>({`+ $${k.empRate}`})</b></div></td> */}

                  {/* </tr> */}
                </tr>
                {item?.vendor_items?.length ? item.vendor_items.map((i, index) => {
                  return (
                    <>
                      {i?.classInfo.map((k) => {
                        return (
                          <tr>
                            {/* <tr style={{ cursor: "pointer", backgroundColor: index % 2 ? "#e6e6e6" : "", padding: "5px" }}> */}

                            <td>
                              <div style={{ width: '40px' }}>
                                {renderGroupCheckbox("small", k.key, k.value, { disabled: true, changeTarget1: 'retireeVendor', changeTargetValue1: item?.vendor_name, changeTarget2: 'retireePlan', changeTargetValue2: i.vendor_code, matchkey: 'retireeVendor', matchvalue: item?.vendor_name, matchkey1: 'retireePlan', matchvalue1: i.vendor_code })}
                              </div>
                            </td>
                            <td>
                              <b style={{ alignSelf: "center" }}>{k.className}</b></td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.amount ? `$${k.amount}` : ''} <b>({`$${k.rate}`})</b></div></td> --old */}
                            <td style={{ width: "200px" }}>{k.label}</td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.amount ? `$${k.amount}` : ''} </div></td> */}
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.empRate}`}</td>
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.govRate}`}</td>
                            <td style={{ borderLeft: "1px solid #d2d2d2" }}>{`$${k.amount}`}</td>
                            {/* <td><div style={{ marginTop: "8px" }}>{k.label} {k.govRate ? `$${k.govRate}` : ''} <b>({`+ $${k.empRate}`})</b></div></td> */}

                            {/* </tr> */}
                          </tr>
                        )
                      })}
                    </>
                  )
                }) : null}



              </table>
            </Card>
          </Col>
        })}


        {/* <Col md={ 6 }>
          

          <div style={{ fontSize: "15px" }}>
            <div><b>Duduction Class for</b></div>
            <div><b>HSA2000 and PPO 1500 Plans</b></div>
          </div>
          {HSAAndPPO?.map((item) => {
            return (
              <div style={{ display: "flex" }}>
                <div style={{width:'110px'}}>{renderCheckbox("small",item.key,item.value)}  <b style={{ alignSelf: "center" }}>{item.className}</b></div>
                <div style={{ marginTop: "8px" }}>{item.label}</div>
              </div>
            )
          })}


        </Col> */}
        {/* <Col md={6}>
          <div style={{ fontSize: "15px" }}>
            <div><b>Duduction Class for RSP</b></div>
          </div>
          {DeductionRSP?.map((item) => {
            return (
              <div style={{ display: "flex" }}>
                <div style={{width:'155px'}}>{renderCheckbox("small", item.key, item.value)}  <b style={{ width: "130px" }}>{item.className}</b></div>
                <div style={{ marginTop: "8px",width:'-webkit-fill-available' }}>{item.label}</div>
              </div>
            )
          })}
        </Col> */}
      </Row>

    </Card>
  )
}

export default RetireePlan